/**
 * ko-predrop-capture.js
 * ------------------------
 * Progressive enhancement note: if this fails to load, the form still
 * submits as a normal full-page-reload Shopify form post (the browser's
 * native behavior) — it just won't get the cinematic transition. That's
 * an acceptable degraded state, not a broken one.
 */
(function () {
  "use strict";

  var settings = window.koPredropSettings || { maxVolume: 0.5, unmuteVideoSelector: ".ko-ambient-video" };

  var form = document.getElementById("ko-ajax-predrop-form");
  if (!form) return;

  var bgMusic = document.getElementById("ko-predrop-bg-music");
  var sfx = document.getElementById("ko-predrop-sfx");
  var audioToggle = document.getElementById("ko-predrop-audio-toggle");

  function fadeVolumeIn(audio, maxVolume) {
    audio.volume = 0;
    audio.play().catch(function () {
      // Blocked despite the submit click being a user gesture — rare,
      // fail silently and leave the toggle visible so the visitor can
      // start it manually if they want to.
    });
    var current = 0;
    var fadeInterval = setInterval(function () {
      current += 0.05;
      if (current >= maxVolume) {
        audio.volume = maxVolume;
        clearInterval(fadeInterval);
      } else {
        audio.volume = current;
      }
    }, 150);
  }

  function toggleAudio() {
    if (!bgMusic) return;
    if (bgMusic.paused) {
      bgMusic.play().catch(function () {});
      audioToggle.setAttribute("aria-pressed", "false");
    } else {
      bgMusic.pause();
      audioToggle.setAttribute("aria-pressed", "true");
    }
  }

  if (audioToggle) {
    audioToggle.addEventListener("click", toggleAudio);
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    if (sfx) {
      sfx.volume = 0.8;
      sfx.play().catch(function () {});
    }

    if (bgMusic) {
      fadeVolumeIn(bgMusic, settings.maxVolume);
      if (audioToggle) audioToggle.hidden = false;
    }

    // Scoped unmute — ONLY videos explicitly opted in via the configured
    // selector (default .ko-ambient-video), never every <video> on the
    // page. Product gallery/demo videos should stay under the shopper's
    // own control, not get unmuted as a side effect of a form submit.
    document.querySelectorAll(settings.unmuteVideoSelector).forEach(function (video) {
      video.muted = false;
      video.play().catch(function () {});
    });

    var formData = new FormData(form);
    fetch(form.action, { method: "POST", body: formData })
      .then(function (response) {
        // NOTE: this /challenge check is an unverified assumption about
        // Shopify's spam-redirect pattern — see the comment in the
        // .liquid file. Test this against a real triggered challenge
        // before trusting it in production.
        if (response.redirected && response.url.indexOf("/challenge") !== -1) {
          window.location.href = response.url;
          return;
        }
        var formContainer = document.getElementById("ko-predrop-form");
        formContainer.classList.add("ko-fade-out");
        setTimeout(function () {
          formContainer.style.display = "none";
          var successContainer = document.getElementById("ko-predrop-success");
          successContainer.classList.add("ko-fade-in");
        }, 400);
      })
      .catch(function () {
        // Network failure — resilient fallback: submit natively rather
        // than silently failing with no feedback to the shopper.
        form.submit();
      });
  });
})();